// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganizationImageBlockAddPage_wrapper__DEf4P"};